import {
  COLORS,
  COLORS_WITHOUT_WHITE,
} from '@/common/utils/constants';


const LABEL_SIZES = {
  xs: 9,
  sm: 10,
  md: 14,
  lg: 16,
  xl: 18,
};

export const DEFAULT_CHART_COLORS = Object.values(COLORS_WITHOUT_WHITE);

export const defaultChartTitleConfig = (title) => ({
  display: title !== null,
  text: title,
  align: 'start',
  padding: {
    top: 5,
    bottom: 30,
  },
  font: {
    size: 13,
    weight: 'bold',
  },
});

export const defaultChartDataLabelConfig = (isSmall, chartConfig) => ({
  opacity: 0,
  color: 'white',
  font: {
    weight: 'bold',
    size: LABEL_SIZES[chartConfig.size || 'md'],
  },
  formatter(value) {
    if (!value) {
      return '';
    }

    if (chartConfig.asPercentageDataLabels) {
      if (value > 3) {
        return `${value}%`;
      }
      return '';
    }
    return value;
  },
});

export const defaultChartOptions = (
  title,
  showLegend,
  isSmall,
  chartConfig,
  showXAxis,
) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: defaultChartTitleConfig(title),
    datalabels: defaultChartDataLabelConfig(isSmall, chartConfig),
    legend: {
      display: showLegend,
      labels: {
        boxWidth: 12,
      },
      onClick() {
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        drawBorder: false,
      },
      ticks: {
        display: showXAxis,
        callback(val) {
          const value = this.getLabelForValue(val);
          if (!value) {
            return val;
          }
          if (value.length > 30) {
            return `${value.slice(0, 30)}...`;
          }
          return value;
        },
      },
    },
    y: {
      display: showXAxis,
      grid: {
        display: false,
      },
      gridLines: {
        drawBorder: false,
      },
    },
  },
});

export const defaultDataLabels = (chartConfig) => ({
  color: COLORS.white,
  opacity: 1,
  font: {
    weight: 'bold',
    size: LABEL_SIZES[chartConfig?.size || 'md'],
  },
});

export const getBgPlugin = async () => {
  // Plugin block;
  const image = new Image();
  // eslint-disable-next-line global-require
  image.src = require('@/common/assets/img/logo-xs.png');
  await image.decode();

  const imageProportion = image.width / image.height;
  const imageHeight = window.innerWidth > 1600 ? 40 : 30;
  const imageWidth = imageHeight * imageProportion;

  return {
    id: 'chartAreaBg',
    beforeDraw(chart) {
      const { ctx } = chart;

      ctx.drawImage(
        image,
        chart.chartArea.right - imageWidth - 10,
        5,
        imageWidth,
        imageHeight,
      );
    },
  };
};

export const downloadChart = async (chart, name) => {
  const a = document.createElement('a');
  a.href = chart.toDataURL('image/png');
  const now = new Date();
  a.download = `${name}-${now.getFullYear()}-${now.getMonth()}`
    + `-${now.getDate()}-${now.getHours()}-${now.getMinutes()}.png`;
  await a.click();
};

export const copyChart = async (chart) => {
  const chartDownload = chart.toDataURL('image/png');
  const blob = await fetch(chartDownload).then((r) => r.blob());
  await navigator.clipboard.write(
    // eslint-disable-next-line no-undef
    [new ClipboardItem({ [blob.type]: blob })],
  );
};
